// extracted by mini-css-extract-plugin
export var carrierIcon = "_vb-0";
export var carrierLogo = "_vb-1";
export var detailsSection = "_vb-2";